module.exports = __webpack_public_path__ + "img/lg_ring_y_e_null_1.fe7d7705.png";